import { render } from "./AddressGenerel.vue?vue&type=template&id=41fb53dd&scoped=true"
import script from "./AddressGenerel.vue?vue&type=script&lang=js"
export * from "./AddressGenerel.vue?vue&type=script&lang=js"

import "./AddressGenerel.vue?vue&type=style&index=0&id=41fb53dd&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fb53dd"]])

export default __exports__